import { msToUnixTimestamp } from 'utils/formateDate';
import { UserPoolInfo } from 'api/StakingAPI';
import { ethers } from 'ethers';

export function calcDiffBetweenUnlockDateAndCurrentDate(
  userPoolInfo: UserPoolInfo,
  timestamp: number
) {
  const unlockTimestamp = parseInt(userPoolInfo?.unlockDate || '0', 10);
  const currentTimestamp = msToUnixTimestamp(timestamp);
  return unlockTimestamp - currentTimestamp;
}

export function calcCurrentLockedPeriodInSeconds(
  userPoolInfo: UserPoolInfo,
  timestamp: number
) {
  const diff = calcDiffBetweenUnlockDateAndCurrentDate(userPoolInfo, timestamp);
  return Math.max(diff, 0);
}

export function calcNewLockedPeriodInSeconds(
  userPoolInfo: UserPoolInfo,
  lockedPeriodSeconds: number,
  timestamp: number
) {
  const diff = calcDiffBetweenUnlockDateAndCurrentDate(userPoolInfo, timestamp);
  // if unlock date is in the past, start new locked period from now
  // https://github.com/Singularity-DAO/staking-reward-contracts/blob/main/contracts/SDAOLockedStaking.sol#L235
  const absDiff = Math.max(diff, 0);

  if (lockedPeriodSeconds > 0) {
    return lockedPeriodSeconds + absDiff;
  }

  // +1 second - new locked period should be greater than current value
  return absDiff + 1;
}

export function isUserStaked(userPoolInfo: UserPoolInfo) {
  const bnTotalStaked = ethers.BigNumber.from(userPoolInfo?.totalStaked || 0);
  const bnClaimable = ethers.BigNumber.from(userPoolInfo?.claimable || 0);

  return bnTotalStaked.gt(0) || bnClaimable.gt(0);
}
